module.exports = __webpack_public_path__ + "static/media/file_icon.6f0c8f3b.svg";